/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Settings
 */
export interface Settings {
    /**
     * 
     * @type {string}
     * @memberof Settings
     */
    serverURL?: string;
    /**
     * 
     * @type {string}
     * @memberof Settings
     */
    errorHelpURL?: string;
    /**
     * 
     * @type {string}
     * @memberof Settings
     */
    userGuideURL?: string;
    /**
     * 
     * @type {string}
     * @memberof Settings
     */
    contractHelpURL?: string;
    /**
     * 
     * @type {string}
     * @memberof Settings
     */
    security?: string;
    /**
     * 
     * @type {string}
     * @memberof Settings
     */
    version?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Settings
     */
    rnrPatterns?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof Settings
     */
    elderAge?: string;
}

/**
 * Check if a given object implements the Settings interface.
 */
export function instanceOfSettings(value: object): value is Settings {
    return true;
}

export function SettingsFromJSON(json: any): Settings {
    return SettingsFromJSONTyped(json, false);
}

export function SettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): Settings {
    if (json == null) {
        return json;
    }
    return {
        
        'serverURL': json['serverURL'] == null ? undefined : json['serverURL'],
        'errorHelpURL': json['errorHelpURL'] == null ? undefined : json['errorHelpURL'],
        'userGuideURL': json['userGuideURL'] == null ? undefined : json['userGuideURL'],
        'contractHelpURL': json['contractHelpURL'] == null ? undefined : json['contractHelpURL'],
        'security': json['security'] == null ? undefined : json['security'],
        'version': json['version'] == null ? undefined : json['version'],
        'rnrPatterns': json['rnrPatterns'] == null ? undefined : json['rnrPatterns'],
        'elderAge': json['elderAge'] == null ? undefined : json['elderAge'],
    };
}

export function SettingsToJSON(json: any): Settings {
    return SettingsToJSONTyped(json, false);
}

export function SettingsToJSONTyped(value?: Settings | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'serverURL': value['serverURL'],
        'errorHelpURL': value['errorHelpURL'],
        'userGuideURL': value['userGuideURL'],
        'contractHelpURL': value['contractHelpURL'],
        'security': value['security'],
        'version': value['version'],
        'rnrPatterns': value['rnrPatterns'],
        'elderAge': value['elderAge'],
    };
}

